import { useId } from "react";

import { Text } from "../../../../core/Text.js";
import { cn } from "../../../../foundations/cn.js";
import { Section } from "../../../../patterns/Section.js";
import { PullRow } from "../../../shared/PullRow.js";
import type { RecentOpensContent } from "../../homeContent.js";

/**
 * The shopper's own best pulls, each opening its details; nothing for none. The `compact` variant is a
 * glance of small cards; `cards` sets each pull as an ItemCard (pull) in its rarity, on a carousel.
 */
export function HomeRecentOpens({
  variant = "compact",
  title,
  opens,
}: RecentOpensContent & { variant?: "compact" | "cards" }) {
  const id = useId();
  if (opens.length === 0) return null;
  const cards = variant === "cards";
  // As a carousel's heading it takes a quiet section title's size, level with the rails around it.
  const heading = (
    <Text
      as="h2"
      id={id}
      variant={cards ? "display-xl3" : "display-xl4"}
      tone="primary"
      className={cn(cards && "max-md:text-display-xl4")}
    >
      {title}
    </Text>
  );
  if (cards) {
    return (
      // The Carousel is the region, named by the title, so the section names nothing.
      <Section>
        <PullRow opens={opens} look="cards" label={title} heading={heading} />
      </Section>
    );
  }
  return (
    <Section aria-labelledby={id} className="flex flex-col gap-5">
      {heading}
      <PullRow opens={opens} />
    </Section>
  );
}
